/*
 * @Author: Src
 * @Date: 2025-07-15 09:14:42
 * @LastEditTime: 2025-08-12 20:31:59
 * @LastEditors: Src
 * @FilePath: /work-station/src/models/carFieldFactory.ts
 * @Description: 头部注释配置模板
 */
import { ECarSPUField } from '@/common/enum/carSpu';
import { ICarSPUField } from '@/common/interface/carSpu';
import _ from 'lodash';
// import { isValidVIN } from '@/common/utils';

export class CarFieldFactory {
  static init(params: {
    spuType: 'car' | 'audit';
    // originalPriceValidator?: (
    //   rule: { [key: string]: string | (() => boolean) },
    //   value: string,
    // ) => boolean;
    // vipPriceValidator?: (
    //   rule: { [key: string]: string | (() => boolean) },
    //   value: string,
    // ) => boolean;
    // newUserPriceValidator?: (
    //   rule: { [key: string]: string | (() => boolean) },
    //   value: string,
    // ) => boolean;

    // tyreSpecValidator?: (
    //   rule: { [key: string]: string | (() => boolean) },
    //   value: string,
    // ) => boolean;
  }) {
    let spuFields: ICarSPUField[] = [];
    const {
      spuType,
      // originalPriceValidator,
      // vipPriceValidator,
      // newUserPriceValidator,
      // tyreSpecValidator,
    } = params;
    if (spuType === 'car') {
      spuFields = _.cloneDeep(ICarSPUFields);
    }
    if (spuType === 'audit') {
      spuFields = _.cloneDeep(ICarAuSPUFields);
    }
    return spuFields;
  }

  static numberValidator(
    rule: { [key: string]: string | (() => boolean) },
    value: string,
  ) {
    return !isNaN(+value);
  }

  static categoryValidator(
    rule: { [key: string]: string | (() => boolean) },
    value: any,
  ) {
    return value != null && value.id !== 0;
  }
}

/** 普通SPU 字段配置项 */
const ICarSPUFields: ICarSPUField[] = [

  {
    label: ECarSPUField.BRAND_CAR_SERIES_MODELS,
    labelName: '车型',
    placeholder: '请输入车辆',
    rule: [{ required: true, message: '请输入服务名称', trigger: 'blur' }],
    step: 1,
  },
  {
    label: ECarSPUField.VIN_CODE,
    labelName: 'VIN码',
    placeholder: '请输入VIN码',
    rule: [
      {
        required: true,
        validator: (
          rule: { [key: string]: string | (() => boolean) },
          value: string,
        ) => {
          if (!value) {
            return false;
          }
          return true;
        },
        message: 'VIN不能为空',
        trigger: 'blur',
      },
      {
        validator: (
          rule: { [key: string]: string | (() => boolean) },
          value: string,
        ) => {
          return value.length === 17;
        },
        message: 'VIN码长度为17位',
        trigger: 'blur',
      },
      {
        validator: (
          rule: { [key: string]: string | (() => boolean) },
          value: string,
        ) => {
          const _isValidVIN = value.toUpperCase();
          return !_isValidVIN.includes('I') && !_isValidVIN.includes('O') && !_isValidVIN.includes('Q');
        },
        message: 'VIN码格式正确,不能包含I、O、Q',
        trigger: 'blur',
      },
    ],
    step: 1,

  },
  {
    label: ECarSPUField.LITER,
    labelName: '排量',
    placeholder: '请输入排量',
    step: 1,

  },
  {
    label: ECarSPUField.GEAR_NAME,
    labelName: '变速箱',
    placeholder: '请输入变速箱',
    step: 1,

  },
  // {
  //   label: 'ECarSPUField.USE_TO',
  //   labelName: '出场日期',
  //   placeholder: '请输入用途',
  //   step: 1,

  // },
  {
    label: ECarSPUField.FIRST_REGISTRATION_DATE,
    labelName: '首次上牌时间',
    placeholder: '请选择首次上牌时间',
    rule: [{ required: true, message: '请选择首次上牌时间', trigger: 'blur' }],
    step: 1,

  },
  {
    label: ECarSPUField.MILEAGE,
    labelName: '表显里程(万公里)',
    placeholder: '请输入里程',
    rule: [{ required: true, message: '请输入里程', trigger: 'blur' }],
    step: 1,

  },
  // {
  //   label: ECarSPUField.CAR_LOCATION,
  //   labelName: '车辆所在地',
  //   placeholder: '请输入亮点',
  //   step: 1,

  // },
  {
    label: ECarSPUField.TRANSFER_TIMES,
    labelName: '过户次数',
    placeholder: '请输入过户次数',
    rule: [{ required: true, message: '请输入过户次数', trigger: 'blur' }],
    step: 1,

  },
  {
    label: ECarSPUField.USE_TO,
    labelName: '用途',
    placeholder: '请选择用途',
    rule: [{ required: true, message: '请选择用途', trigger: 'blur' }],
    step: 1,

  },
  // {
  //   label: ECarSPUField.CERTIFICATE_INFO,
  //   labelName: '库存状态',
  //   placeholder: '请输入登记证情况',
  // },
  {
    label: ECarSPUField.COLOR,
    labelName: '车身颜色',
    placeholder: '请选择车身颜色',
    rule: [{ required: true, message: '请选择车身颜色', trigger: 'blur' }],
    step: 1,

  },
  // {
  //   label: ECarSPUField.EXTERIOR_INFO,
  //   labelName: '外观成色',
  //   placeholder: '请输入外观成色',
  //   step: 1,

  // },
  {
    label: ECarSPUField.INTERIOR_COLOR,
    labelName: '内饰颜色',
    placeholder: '请选择内饰颜色',
    // rule: [{ required: true, message: '请选择内饰颜色', trigger: 'blur' }],
    step: 1,

  },
  // {
  //   label: ECarSPUField.ACCIDENT_INFO,
  //   labelName: '事故情况',
  //   placeholder: '请输入事故情况',
  //   step: 1,

  // },
  {
    label: ECarSPUField.HIGHLIGHTS,
    labelName: '亮点配置',
    placeholder: '请输入销售卖点',
    step: 1,

  },
  {
    label: ECarSPUField.REFIT_CHARGE,
    labelName: '加装价格(元)',
    placeholder: '请输入加装价格',
    step: 1,

  },
  {
    label: ECarSPUField.EVALUATION_PRICE,
    labelName: '评估价格(万元)',
    placeholder: '请输入评估价格',
    step: 1,

  },

  {
    label: ECarSPUField.HEADER_IMAGE,
    labelName: '车辆头图',
    // readonly: true,
    rule: [{ required: true, message: '请上传车辆头图', trigger: 'blur' }],
    step: 1,
  },
  {
    label: ECarSPUField.CAR_IMAGES,
    labelName: '车辆相册',
    // readonly: true,
    rule: [{ required: true, message: '请上传车辆相册', trigger: 'blur' }],
    step: 1,
  },

  {
    label: ECarSPUField.VERIFICATION_IMAGES,
    labelName: '车源验证',
    placeholder: '请输入商品名称',
    rule: [{ required: true, message: '请上传车源验证', trigger: 'blur' }],
    step: 1,
  },

  {
    label: ECarSPUField.VEHICLE_SOURCE_PROCEDURE_INFORMATION,
    labelName: '车源手续信息',
    step: 2,
  },
  {
    label: ECarSPUField.VEHICLE_SOURCE_INFORMATION,
    labelName: '车源情况息',
    step: 2,
  },
  {
    label: ECarSPUField.VEHICLE_SOURCE_PRICE_INFORMATION,
    labelName: '车源价格信息',
    step: 2,
  },
  {
    label: ECarSPUField.INFORMATION_ON_THE_LOCATION_OF_THE_VEHICLE_SOURCE,
    labelName: '车源所在地信息',
    step: 2,
  },
  {
    label: ECarSPUField.LICENSE_INFORMATION_MODULE,
    labelName: '牌证信息',
    step: 2,
  },
  {
    label: ECarSPUField.DESCRIPTION,
    labelName: '车况信息',
    step: 3,
  },
  //   {
  //   label: ECarSPUField.AUTOMATIC_SHELVING,
  //   labelName: '自动上架',
  //   step: 3,
  // },
  //   {
  //   label: ECarSPUField.AUTOMATIC_DELISTING,
  //   labelName: '自动下架',
  //   step: 3,
  // },
];

/** 普通SPU 字段配置项 */
const ICarAuSPUFields: ICarSPUField[] = [

  {
    label: ECarSPUField.NAME,
    labelName: '车辆',
    placeholder: '请输入车辆',
    rule: [{ required: true, message: '请输入服务名称', trigger: 'blur' }],
    step: 1,
  },
  {
    label: ECarSPUField.VIN_CODE,
    labelName: 'VIN码',
    placeholder: '请输入里程',
    rule: [
      { required: true, message: '请输入服务名称', trigger: 'blur' },
      {
        validator: (
          rule: { [key: string]: string | (() => boolean) },
          value: string,
        ) => {
          return value.length !== 17;
        },
        message: 'VIN码长度为17位',
        trigger: 'blur',
      },
    ],
    step: 1,

  },

  {
    label: ECarSPUField.FIRST_REGISTRATION_DATE,
    labelName: '首次上牌时间',
    placeholder: '请输入颜色',
    step: 1,

  },
  {
    label: ECarSPUField.MILEAGE,
    labelName: '表显里程(万公里)',
    placeholder: '请输入里程',
    step: 1,

  },

  {
    label: ECarSPUField.TRANSFER_TIMES,
    labelName: '过户次数',
    placeholder: '请输入描述',
    step: 1,

  },
  {
    label: ECarSPUField.USE_TO,
    labelName: '用途',
    placeholder: '请输入价格',
    step: 1,

  },
  {
    label: ECarSPUField.COLOR,
    labelName: '车身颜色',
    placeholder: '请输入保养情况',
    step: 1,

  },
  {
    label: ECarSPUField.INTERIOR_COLOR,
    labelName: '内饰颜色',
    placeholder: '请输入内饰情况',
    step: 1,

  },
  {
    label: ECarSPUField.HIGHLIGHTS,
    labelName: '亮点配置',
    placeholder: '请输入销售卖点',
    step: 1,

  },
  {
    label: ECarSPUField.REFIT_CHARGE,
    labelName: '加装价格(元)',
    placeholder: '请输入销售卖点',
    step: 1,

  },
  {
    label: ECarSPUField.EVALUATION_PRICE,
    labelName: '评估价格(万元)',
    placeholder: '请输入销售卖点',
    step: 1,

  },

  {
    label: ECarSPUField.HEADER_IMAGE,
    labelName: '车辆头图',
    // readonly: true,
    step: 1,
  },
  {
    label: ECarSPUField.CAR_IMAGES,
    labelName: '车辆相册',
    // readonly: true,
    step: 1,
  },

  {
    label: ECarSPUField.VERIFICATION_IMAGES,
    labelName: '车源验证',
    placeholder: '请输入商品名称',
    step: 1,
  },

  {
    label: ECarSPUField.VEHICLE_SOURCE_PROCEDURE_INFORMATION,
    labelName: '车源手续信息',
    step: 2,
  },
  {
    label: ECarSPUField.VEHICLE_SOURCE_INFORMATION,
    labelName: '车源情况息',
    step: 2,
  },
  {
    label: ECarSPUField.VEHICLE_SOURCE_PRICE_INFORMATION,
    labelName: '车源价格信息',
    step: 2,
  },
  {
    label: ECarSPUField.INFORMATION_ON_THE_LOCATION_OF_THE_VEHICLE_SOURCE,
    labelName: '车源所在地信息',
    step: 2,
  },
  {
    label: ECarSPUField.LICENSE_INFORMATION_MODULE,
    labelName: '牌证信息',
    step: 2,
  },
  {
    label: ECarSPUField.DESCRIPTION,
    labelName: '车况信息',
    step: 3,
  },
  //   {
  //   label: ECarSPUField.AUTOMATIC_SHELVING,
  //   labelName: '自动上架',
  //   step: 3,
  // },
  //   {
  //   label: ECarSPUField.AUTOMATIC_DELISTING,
  //   labelName: '自动下架',
  //   step: 3,
  // },
];

